















































































import { Vue, Component, Prop, Emit, Watch } from 'vue-property-decorator'
import ExtensionCategoryListModel from '@/models/extension/extensionCategoryListModel'
import ExtensionCategoryQuestionModel from '@/models/extension/extensionCategoryQuestionModel'
import ExtensionCategoryQuestionAnswerModel from '@/models/extension/extensionCategoryQuestionAnswerModel'
import apiService from '../../services/apiService'
import { UrlType } from '@/constants/urlType'
import Sortable from 'sortablejs'

@Component
export default class QuestionListAdmin extends Vue {
  @Prop(Object) readonly category!: ExtensionCategoryListModel

  private async created() {
    var self = this
    this.$nextTick(function() {
      let list = document.querySelector(
        '.' + 'question-list-' + this.category.order
      )
      Sortable.create(list, {
        handle: '.draghandle',
        async onEnd({
          newIndex,
          oldIndex
        }: {
          newIndex: number
          oldIndex: number
        }) {
          const itemSelected = self.category.extensionCategoryQuestions.splice(
            oldIndex,
            1
          )[0]
          self.category.extensionCategoryQuestions.splice(
            newIndex,
            0,
            itemSelected
          )
          await self.updateOrder(self.category)
        }
      })
    })
  }

  private async checkBarrier(question: ExtensionCategoryQuestionModel) {
    question.isBarrier = !question.isBarrier
    await this.updateQuestion(question)
  }

  private async checkChange(question: ExtensionCategoryQuestionModel) {
    question.isChange = !question.isChange
    await this.updateQuestion(question)
  }

  private async checkHumanFactor(question: ExtensionCategoryQuestionModel) {
    question.isHumanFactor = !question.isHumanFactor
    await this.updateQuestion(question)
  }

  private async checkEvent(question: ExtensionCategoryQuestionModel) {
    question.isEvent = !question.isEvent
    await this.updateQuestion(question)
  }

  private async checkData(question: ExtensionCategoryQuestionModel) {
    question.isData = !question.isData
    await this.updateQuestion(question)
  }

  @Emit()
  private async updateOrder(category: ExtensionCategoryListModel) {
    for (let i = 0; i < category.extensionCategoryQuestions.length; i++) {
      let item = category.extensionCategoryQuestions[i]
      item.order = i
    }
    await apiService.put(
      UrlType.ExtensionCategoryQuestion + '/order',
      this.category.extensionCategoryId,
      this.category
    )
  }

  @Emit()
  private async updateQuestion(question: ExtensionCategoryQuestionModel) {
    await apiService.put<ExtensionCategoryQuestionModel>(
      UrlType.ExtensionCategoryQuestion,
      question.extensionCategoryQuestionId,
      question
    )
  }

  @Emit()
  private async deleteQuestion(question: ExtensionCategoryQuestionModel) {
    if (confirm('Are you sure you want to delete this item?')) {
      await apiService.delete(
        UrlType.ExtensionCategoryQuestion,
        question.extensionCategoryQuestionId
      )
    }
  }
}
